import React, { useEffect, useState } from "react";
import { Button, Card, Typography } from "antd";

const { Title, Text } = Typography;

export const Loader = () => (
  <div className="flex items-center justify-center h-full bg-gray-50">
  <div className="flex flex-col items-center gap-7">
    <div className="relative flex items-center justify-center" style={{ width: 72, height: 72 }}>
      <style>{`
        @keyframes orbit1 { from { transform: rotate(0deg) translateX(28px) rotate(0deg); } to { transform: rotate(360deg) translateX(28px) rotate(-360deg); } }
        @keyframes orbit2 { from { transform: rotate(120deg) translateX(28px) rotate(-120deg); } to { transform: rotate(480deg) translateX(28px) rotate(-480deg); } }
        @keyframes orbit3 { from { transform: rotate(240deg) translateX(28px) rotate(-240deg); } to { transform: rotate(600deg) translateX(28px) rotate(-600deg); } }
        @keyframes corePulse { 0%, 100% { transform: scale(1); opacity: 1; } 50% { transform: scale(1.15); opacity: 0.8; } }
        @keyframes dotblink { 0%, 80%, 100% { opacity: 0.2; } 40% { opacity: 1; } }
      `}</style>
      <div className="absolute w-3 h-3 rounded-full bg-violet-500" style={{ animation: "orbit1 1.4s linear infinite" }} />
      <div className="absolute w-2 h-2 rounded-full bg-teal-500" style={{ animation: "orbit2 1.4s linear infinite" }} />
      <div className="absolute w-1.5 h-1.5 rounded-full bg-blue-500" style={{ animation: "orbit3 1.4s linear infinite" }} />
      <div className="w-4 h-4 rounded-full bg-violet-100 border-2 border-violet-500" style={{ animation: "corePulse 1.4s ease-in-out infinite" }} />
    </div>
    <div className="flex items-center gap-1">
      <span className="text-[13px] text-gray-400">Loading</span>
      {[0, 0.2, 0.4].map((delay, i) => (
        <span key={i} className="text-[13px] text-gray-400" style={{ animation: `dotblink 1.2s ease-in-out ${delay}s infinite` }}>.</span>
      ))}
    </div>
  </div>
  </div>
);


const CenteredDisplay = ({
  icon = "📭",
  title,
  description,
  actionText,
  actionCallback,
  isLoading = false,
  timeout=15000
}) => {
  const [internalLoading, setInternalLoading] = useState(true);

  useEffect(() => {
    // If parent is loading, we're loading
    if (isLoading) {
      setInternalLoading(true);
      return;
    }

    // If parent stopped loading, wait 1.5s then stop our loading
    const timer = setTimeout(() => {
      setInternalLoading(false);
    }, timeout);

    return () => clearTimeout(timer);
  }, [isLoading]);

  // Show loader if either parent is loading OR we're in our internal delay
  if (isLoading || internalLoading) {
    return <Loader />;
  }

  return (
    <div className="flex items-center justify-center h-full bg-gray-50">
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <Card
        className="w-[420px] rounded-[20px] text-center border border-gray-100 overflow-hidden relative"
        style={{ animation: "fadeUp 0.5s ease forwards" }}
        styles={{ body: { padding: "48px 40px" } }}
      >
        <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-blue-600 to-violet-600" />
        <div className="w-16 h-16 rounded-[18px] mx-auto mb-6 bg-gray-50 border border-gray-100 grid place-items-center text-[28px]">
          {icon}
        </div>
        <Title level={4} className="!text-slate-900 !tracking-tight !mb-2.5">
          {title}
        </Title>
        <Text type="secondary" className="text-sm leading-relaxed block mb-8">
          {description}
        </Text>
        { actionText &&
        <Button
          onClick={actionCallback}
          type="primary"
          size="large"
          className="!bg-gradient-to-br !from-blue-600 !to-blue-700 !border-none !rounded-[10px] !font-semibold !h-11 !px-7"
        >
          {actionText}
        </Button>}
      </Card>
    </div>
  );
};

export default CenteredDisplay;
